import { render } from "./RegistrationQrCard.vue?vue&type=template&id=00013fc8&ts=true&lang=pug"
import script from "./RegistrationQrCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationQrCard.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__